import ChangeDownIcon from '../../assets/images/ChangeDownIcon.svg';
import ChangeUpIcon from '../../assets/images/ChangeUpIcon.svg';

import { IOverviewAssets } from './IOverviewAssets.js';
/* [AddAsset: import] */

export const overviewAssets: IOverviewAssets = {
	changeIndicator: {
		changeUpIcon: ChangeUpIcon,
		changeDownIcon: ChangeDownIcon,
		/* [AddAsset: changeIndicator] */
	},
	/* [InitComponentAsset: assetKey] */
};
